import { nav2 } from "assets/icons";
import { Navbar } from "components";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { userData } from "utils/userData";

export default function DashboardLayout({ children }) {
  const [close, setClose] = useState(false);
  console.log(close);
  //const closeR = JSON.parse(localStorage.getItem("close"));
  const navigate = useNavigate();

  useEffect(() => {
    if (!userData) {
      navigate("/");
    }
    //eslint-disable-next-line
  }, []);
  return (
    <DashayoutStyle
      style={{
        display: "grid",
        gridTemplateColumns: `${!close ? "2.2fr 9fr" : "0px 1fr"}`,
      }}
    >
      <div>
        <div>
          <Navbar setCloseState={setClose} closeState={close} />
        </div>
      </div>
      <div className="body">
        <div className="body_inner">
          <div style={{ background: "none" }}>
            <div
              style={{
                cursor: "pointer",
                padding: "2px 2px 0px 2px",
                borderRadius: "10000px",
                zIndex: "10",
                width: "fit-content",
              }}
              onClick={() => {
                setClose(!close);
                localStorage.setItem("close", close);
                //navigate(window.location.pathname);
              }}
            >
              <img src={nav2} alt="" />
            </div>
          </div>
          <br></br>
          {children}
        </div>
      </div>
    </DashayoutStyle>
  );
}

const DashayoutStyle = styled.div`
  width: 100%;
  margin: 0 auto;

  .body {
    background-color: #f5fcff;
    height: 100vh;
    overflow: hidden;
    overflow-y: scroll;

    &::-webkit-scrollbar {
      width: 10px;
      padding: 10px;
    }
    &::-webkit-scrollbar-thumb {
      width: 10px;
      background-color: #019edf;
      border-radius: 30px;
    }

    .body_inner {
      padding: 30px;
    }
  }
  @media (max-width: 930px) {
  }
`;
